var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "row justify-content-center" }, [
      _vm.registered
        ? _c("div", { staticClass: "col text-center" }, [
            _c("div", { staticClass: "row justify-content-center" }, [
              _c("h5", { staticClass: "text-white mt-5" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t("message.lastStepToRegister")) +
                    "\n                "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row justify-content-center" }, [
              _c("h6", { staticClass: "text-white" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(`${_vm.$t("message.checkActivationMail")} `)
                ),
                _c("strong", [_vm._v(_vm._s(_vm.mail))]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("div", { staticClass: "d-flex justify-content-center" }, [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$t("message.expireDateWarning")) +
                      "\n                    "
                  ),
                ]),
              ]),
            ]),
          ])
        : _c("div", { staticClass: "form-container" }, [
            _c("div", { staticClass: "card bg-transparent border-0" }, [
              _c(
                "div",
                { staticClass: "card-body pt-0 pb-0" },
                [
                  _c(
                    "b-tabs",
                    {
                      attrs: {
                        "active-nav-item-class": "active-tab-class",
                        "nav-class": "title-nav-class",
                        "no-nav-style": "",
                        "no-fade": "",
                      },
                      on: { "activate-tab": _vm.emptyInput },
                      model: {
                        value: _vm.tabIndex,
                        callback: function ($$v) {
                          _vm.tabIndex = $$v
                        },
                        expression: "tabIndex",
                      },
                    },
                    [
                      _c(
                        "b-tab",
                        {
                          attrs: {
                            title: _vm.$t("title.login"),
                            "title-link-class": "tab-class",
                          },
                        },
                        [
                          _vm.features.vkAuth
                            ? _c("vk-login", {
                                attrs: { usage: "login", link: _vm.vkLink },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("ValidationObserver", { ref: "loginObserver" }, [
                            _c(
                              "form",
                              { staticClass: "mt-3", attrs: { id: "login" } },
                              [
                                _c("v-input", {
                                  staticClass: "input-w-default mb-0 mx-auto",
                                  attrs: {
                                    ind: "0",
                                    type: "text",
                                    placeholder: _vm.$t("placeholder.email"),
                                    icon: _vm.$getInputIcon(_vm.login, "email"),
                                    rules: "required",
                                    autocomplete: "username",
                                    autofocus: "",
                                  },
                                  on: {
                                    input: _vm.clearError,
                                    keyEnterUp: _vm.signIn,
                                  },
                                  model: {
                                    value: _vm.login,
                                    callback: function ($$v) {
                                      _vm.login = $$v
                                    },
                                    expression: "login",
                                  },
                                }),
                                _vm._v(" "),
                                _c("v-input", {
                                  staticClass:
                                    "input-w-default mb-0 mx-auto mt-2",
                                  attrs: {
                                    ind: "1",
                                    type: _vm.openPasswordLogin
                                      ? "text"
                                      : "password",
                                    placeholder: _vm.$t("placeholder.password"),
                                    icon: _vm.$getInputIcon(
                                      _vm.password,
                                      "password"
                                    ),
                                    rules: "required",
                                    autocomplete: "current-password",
                                  },
                                  on: {
                                    input: _vm.clearError,
                                    keyEnterUp: _vm.signIn,
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "password",
                                      fn: function () {
                                        return [
                                          _c("password-eye", {
                                            model: {
                                              value: _vm.openPasswordLogin,
                                              callback: function ($$v) {
                                                _vm.openPasswordLogin = $$v
                                              },
                                              expression: "openPasswordLogin",
                                            },
                                          }),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ]),
                                  model: {
                                    value: _vm.password,
                                    callback: function ($$v) {
                                      _vm.password = $$v
                                    },
                                    expression: "password",
                                  },
                                }),
                                _vm._v(" "),
                                _vm.error !== ""
                                  ? _c(
                                      "b-form-invalid-feedback",
                                      {
                                        staticClass: "center-element",
                                        staticStyle: { width: "90%" },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                        " +
                                            _vm._s(_vm.error) +
                                            "\n                                    "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "b-button",
                                  {
                                    staticClass:
                                      "center-element enter-button w-75 mb-2",
                                    on: { click: _vm.signIn },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(_vm.$t("button.login")) +
                                        "\n                                    "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "center-element small text-link mt-2",
                                    staticStyle: {
                                      width: "fit-content",
                                      cursor: "pointer",
                                    },
                                    on: { click: _vm.restore },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(
                                          _vm.$t("message.forgotPassword")
                                        ) +
                                        "\n                                    "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-tab",
                        {
                          attrs: {
                            title: _vm.$t("title.register"),
                            "title-link-class": "tab-class",
                          },
                        },
                        [
                          _c(
                            "ValidationObserver",
                            { ref: "registerObserver" },
                            [
                              _c(
                                "form",
                                { attrs: { id: "registerStudent" } },
                                [
                                  _vm.features.vkAuth
                                    ? _c("vk-login", {
                                        attrs: {
                                          usage: "register",
                                          link: _vm.vkLink,
                                        },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("v-input", {
                                    staticClass:
                                      "input-w-default mt-3 mb-0 mx-auto",
                                    attrs: {
                                      ind: "2",
                                      type: "text",
                                      placeholder: _vm.$t(
                                        "placeholder.surname"
                                      ),
                                      icon: _vm.$getInputIcon(
                                        _vm.surname,
                                        "name"
                                      ),
                                      rules: "required",
                                    },
                                    model: {
                                      value: _vm.surname,
                                      callback: function ($$v) {
                                        _vm.surname = $$v
                                      },
                                      expression: "surname",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("v-input", {
                                    staticClass:
                                      "input-w-default mb-0 mx-auto mt-2",
                                    attrs: {
                                      ind: "3",
                                      type: "text",
                                      placeholder: _vm.$t("placeholder.name"),
                                      icon: _vm.$getInputIcon(_vm.name, "name"),
                                      rules: "required",
                                    },
                                    model: {
                                      value: _vm.name,
                                      callback: function ($$v) {
                                        _vm.name = $$v
                                      },
                                      expression: "name",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("v-input", {
                                    staticClass:
                                      "input-w-default mb-0 mx-auto mt-2",
                                    attrs: {
                                      ind: "4",
                                      type: "text",
                                      placeholder: _vm.$t("placeholder.email"),
                                      icon: _vm.$getInputIcon(
                                        _vm.mail,
                                        "email"
                                      ),
                                      debounce: 500,
                                      rules: "required|email|emailNotExists",
                                      autocomplete: "username",
                                    },
                                    model: {
                                      value: _vm.mail,
                                      callback: function ($$v) {
                                        _vm.mail = $$v
                                      },
                                      expression: "mail",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("v-input", {
                                    staticClass:
                                      "input-w-default mb-0 mx-auto mt-2",
                                    attrs: {
                                      ind: "5",
                                      type: "password",
                                      name: "password",
                                      placeholder: _vm.$t(
                                        "placeholder.password"
                                      ),
                                      icon: _vm.$getInputIcon(
                                        _vm.password,
                                        "password"
                                      ),
                                      rules: { required: true, min: 6 },
                                      autocomplete: "new-password",
                                    },
                                    model: {
                                      value: _vm.password,
                                      callback: function ($$v) {
                                        _vm.password = $$v
                                      },
                                      expression: "password",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("v-input", {
                                    staticClass: "input-w-default mx-auto mt-2",
                                    attrs: {
                                      ind: "6",
                                      type: "password",
                                      name: "passwordConfirm",
                                      placeholder: _vm.$t(
                                        "placeholder.repeatPassword"
                                      ),
                                      icon: _vm.$getInputIcon(
                                        _vm.passwordConfirm,
                                        "password"
                                      ),
                                      rules: "required|confirmed:password",
                                      autocomplete: "new-password",
                                    },
                                    model: {
                                      value: _vm.passwordConfirm,
                                      callback: function ($$v) {
                                        _vm.passwordConfirm = $$v
                                      },
                                      expression: "passwordConfirm",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("ValidationProvider", {
                                attrs: { rules: { isTrue: true }, slim: "" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function ({ errors }) {
                                      return [
                                        _c(
                                          "b-form-checkbox",
                                          {
                                            staticClass:
                                              "text-white small mx-auto agreements-checkbox",
                                            attrs: {
                                              id: "confirmUserAgreementAndPrivacyPolicy",
                                            },
                                            model: {
                                              value:
                                                _vm.confirmUserAgreementAndPrivacyPolicy,
                                              callback: function ($$v) {
                                                _vm.confirmUserAgreementAndPrivacyPolicy =
                                                  $$v
                                              },
                                              expression:
                                                "confirmUserAgreementAndPrivacyPolicy",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                        " +
                                                _vm._s(
                                                  _vm.$t("message.acceptTerms")
                                                ) +
                                                "\n                                        \n                                        "
                                            ),
                                            _c("br"),
                                            _vm._v(" "),
                                            _c(
                                              "router-link",
                                              {
                                                staticClass: "text-link",
                                                attrs: {
                                                  to: "/user-agreement",
                                                  target: "_blank",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                            " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "title.userAgreementGenitive"
                                                      )
                                                    ) +
                                                    "\n                                        "
                                                ),
                                              ]
                                            ),
                                            _vm._v(
                                              "\n                                        \n                                        " +
                                                _vm._s(
                                                  ` ${_vm.$t("message.and")}\n`
                                                ) +
                                                "\n                                        \n                                        "
                                            ),
                                            _c("br"),
                                            _vm._v(" "),
                                            _c(
                                              "router-link",
                                              {
                                                staticClass: "text-link",
                                                attrs: {
                                                  to: "/privacy-policy",
                                                  target: "_blank",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                            " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "title.privacyPolicyGenitive"
                                                      )
                                                    ) +
                                                    "\n                                        "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        errors.length
                                          ? _c(
                                              "b-popover",
                                              {
                                                attrs: {
                                                  target:
                                                    "confirmUserAgreementAndPrivacyPolicy",
                                                  placement: "left",
                                                  variant: "danger",
                                                  show: "",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "message.confirmTerms"
                                                      )
                                                    ) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _vm._v(" "),
                              _c("ValidationProvider", {
                                attrs: { rules: { isTrue: true }, slim: "" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function ({ errors }) {
                                      return [
                                        _c(
                                          "b-form-checkbox",
                                          {
                                            staticClass:
                                              "text-white small mx-auto agreements-checkbox",
                                            attrs: {
                                              id: "confirmPersonalDataAgreement",
                                            },
                                            model: {
                                              value:
                                                _vm.confirmPersonalDataAgreement,
                                              callback: function ($$v) {
                                                _vm.confirmPersonalDataAgreement =
                                                  $$v
                                              },
                                              expression:
                                                "confirmPersonalDataAgreement",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                        " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "message.acceptPersonalDataAgreement"
                                                  )
                                                ) +
                                                "\n                                        \n                                        "
                                            ),
                                            _c(
                                              "router-link",
                                              {
                                                staticClass: "text-link",
                                                attrs: {
                                                  to: "/personal-data-agreement",
                                                  target: "_blank",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                            " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "title.personalDataAgreement"
                                                      )
                                                    ) +
                                                    "\n                                        "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        errors.length
                                          ? _c(
                                              "b-popover",
                                              {
                                                attrs: {
                                                  target:
                                                    "confirmPersonalDataAgreement",
                                                  placement: "left",
                                                  variant: "danger",
                                                  show: "",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "message.confirmTerms"
                                                      )
                                                    ) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-checkbox",
                            {
                              staticClass:
                                "text-white small mx-auto mt-4 input-w-default",
                              attrs: { id: "acceptedMailing" },
                              model: {
                                value: _vm.acceptedMailing,
                                callback: function ($$v) {
                                  _vm.acceptedMailing = $$v
                                },
                                expression: "acceptedMailing",
                              },
                            },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    `${_vm.$t("message.acceptedMailing")} `
                                  ) +
                                  "\n                            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.error !== ""
                            ? _c(
                                "b-form-invalid-feedback",
                                { staticClass: "center-element" },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(_vm.error) +
                                      "\n                            "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              staticClass: "center-element enter-button px-5",
                              attrs: {
                                disabled:
                                  !_vm.confirmPersonalDataAgreement ||
                                  !_vm.confirmUserAgreementAndPrivacyPolicy,
                              },
                              on: { click: _vm.register },
                            },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(_vm.$t("button.register")) +
                                  "\n                            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }